/* Modulo: Sale Countdown banners (New Year / Valentine) — shared runtime.
   Server renders the initial countdown numbers (no CLS); this ticks each second,
   handles completion, and copies the discount code. Generic data-* hooks so both
   sibling sections (modulo-cny / modulo-cvl) reuse one file. Vanilla IIFE,
   lazy-init, reduced-motion aware. */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  function pad2(n) { n = Math.max(0, Math.floor(n)); return n < 10 ? '0' + n : String(n); }

  function initSection(el) {
    // ─── Countdown ───
    var endAttr = el.getAttribute('data-end-ms');
    var endMs = endAttr ? parseInt(endAttr, 10) : 0;
    var onComplete = el.getAttribute('data-on-complete') || 'show-message';
    var timer = el.querySelector('[data-scb-timer]');
    var timerWrap = el.querySelector('[data-scb-timer-wrap]');

    var daysEl    = timer && timer.querySelector('[data-unit="days"]');
    var hoursEl   = timer && timer.querySelector('[data-unit="hours"]');
    var minutesEl = timer && timer.querySelector('[data-unit="minutes"]');
    var secondsEl = timer && timer.querySelector('[data-unit="seconds"]');
    var interval = null;

    function render(diffMs) {
      var diff = Math.max(0, Math.floor(diffMs / 1000));
      // Days box only exists when the server rendered ≥1 day — keep it stable (no CLS).
      if (daysEl)    daysEl.textContent    = String(Math.floor(diff / 86400));
      if (hoursEl)   hoursEl.textContent   = pad2(Math.floor((diff % 86400) / 3600));
      if (minutesEl) minutesEl.textContent = pad2(Math.floor((diff % 3600) / 60));
      if (secondsEl) secondsEl.textContent = pad2(diff % 60);
    }

    function complete() {
      el.setAttribute('data-ended', 'true');
      if (onComplete === 'hide-timer' && timerWrap && timerWrap.parentNode) {
        timerWrap.parentNode.removeChild(timerWrap);
      } else if (onComplete === 'hide-section' && el.parentNode) {
        el.parentNode.removeChild(el);
      }
      // show-message handled in CSS via [data-ended="true"]
    }

    function start() {
      if (!endMs || !timer) return;
      if (endMs - Date.now() <= 0) { render(0); complete(); return; }
      render(endMs - Date.now());
      interval = setInterval(function () {
        var diff = endMs - Date.now();
        if (diff <= 0) {
          render(0);
          clearInterval(interval); interval = null;
          complete();
          return;
        }
        render(diff);
      }, 1000);
    }

    if (timer) {
      if (el.getAttribute('data-ended') === 'true') {
        complete();
        if (onComplete === 'hide-section') return;
      } else {
        start();
      }
    }

    // ─── Copy discount code ───
    var code = el.querySelector('[data-copy]');
    if (code) {
      var status = el.querySelector('[data-scb-status]');
      var textEl = code.querySelector('[data-scb-code-text]');
      code.addEventListener('click', function () {
        var txt = code.getAttribute('data-copy') || '';
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(txt).catch(function () {});
        }
        code.classList.add('is-copied');
        if (status) status.textContent = 'Discount code ' + txt + ' copied';
        var orig = textEl ? textEl.textContent : '';
        if (textEl) textEl.textContent = 'Copied!';
        // Optional: after copying, send the shopper to a collection/cart so they can
        // paste the code at checkout. Short delay so the "Copied!" state is seen.
        var link = code.getAttribute('data-link');
        if (link) {
          setTimeout(function () { window.location.href = link; }, 650);
          return;
        }
        setTimeout(function () {
          code.classList.remove('is-copied');
          if (textEl) textEl.textContent = orig;
        }, 1600);
      });
    }
  }

  function bootstrap() {
    if (window.moduloLazyInit) {
      window.moduloLazyInit('[data-modulo-scb]', initSection);
    } else {
      var els = document.querySelectorAll('[data-modulo-scb]');
      for (var i = 0; i < els.length; i++) initSection(els[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
